import { render } from "./ProfileSideMenu.vue?vue&type=template&id=71aff6ae&scoped=true&ts=true"
import script from "./ProfileSideMenu.vue?vue&type=script&lang=ts"
export * from "./ProfileSideMenu.vue?vue&type=script&lang=ts"

import "./ProfileSideMenu.vue?vue&type=style&index=0&id=71aff6ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71aff6ae"]])

export default __exports__